import { SalesReportData } from '../../domain/entities/SalesReport'
import { SalesReportRepository } from '../../domain/repositories/SalesReportRepository'
import { salesReportApiDatasource } from '../datasources/SalesReportApiDatasource'

export class SalesReportRepositoryImpl implements SalesReportRepository {
  async getSalesReport(): Promise<SalesReportData> {
    return salesReportApiDatasource.getSalesReport()
  }
}

export const salesReportRepository = new SalesReportRepositoryImpl()
